import { useState, useEffect } from "react";
import { Banner } from "../images/index";
import {
  image302,
  Right,
  RGInActive,
  RGActive,
  GSInactive,
  HSInactive,
  LSInactive,
  FSInactive,
  Image24,
  Image301,
  Image303,
  Image304,
  Image305,
  GSActive,
  FSActive,
  HSActive,
  IndustryImage,
  LSactive,
} from "../images/Industries";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { useNavigate } from "react-router-dom";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const industries = [
  {
    name: "Retail & Grocery",
    activeIcon: RGActive,
    inActiveIcon: RGInActive,
    description:
      "AI and automation to optimize demand forecasting, reduce waste, and personalize customer experiences.",
    cta: "Retail",
    image: image302,
    active: true,
  },
  {
    name: "Government & Public Sector",
    activeIcon: GSActive,
    inActiveIcon: GSInactive,
    description:
      "CyberSecurity, compliance, and modernization to protect citizen data and enable digital-first services.",
    image: Image301,
    cta: "Government",
  },
  {
    name: "Healthcare & Life Sciences",
    activeIcon: HSActive,
    inActiveIcon: HSInactive,
    description:
      "Secure, data-driven platforms to improve patient care, ensure compliance, and empower staff.",
    image: Image303,
    cta: "Healthcare",
  },
  {
    name: "Logistics & Supply Chain",
    activeIcon: LSactive,
    inActiveIcon: LSInactive,
    description:
      "AI, IoT, and automation to optimize delivery networks, reduce costs, and streamline operations.",
    image: Image304,
    cta: "Logistics",
  },
  {
    name: "Financial Services",
    activeIcon: FSActive,
    inActiveIcon: FSInactive,
    description:
      "Fraud prevention, risk modeling, and customer experience solutions for banks, insurers, and fintechs.",
    image: Image305,
    cta: "Financial",
  },
];

function Industries() {
  const [selected, setSelected] = useState(0);
  const navigate = useNavigate();
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);

  const navTo = (e) => {
    if (e === "Retail") {
      navigate("/Industries/RWG");
    } else if (e === "Government") {
      navigate("/Industries/GPS");
    } else if (e === "Healthcare") {
      navigate("/Industries/HLS");
    } else if (e === "Logistics") {
      navigate("/Industries/LSC");
    } else if (e === "Financial") {
      navigate("/Industries/FS");
    }
  };

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-2xl font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  WHERE TECHNOLOGY MEETS INDUSTRY
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Industries We Serve
              </h1>
              <p className="text-md text-[#404040]">
                From retail to public sector, healthcare to finance, we deliver
                solutions built around the unique needs of each industry.
              </p>
            </div>

            <div className="max-w-xl flex justify-end">
              <img src={IndustryImage} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="bg-white py-16 px-6 md:px-12 relative overflow-hidden font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div className="relative flex justify-center md:justify-start">
              <div className="absolute top-8 left-8 w-64 h-72 bg-red-500 rounded-[2rem] -z-10"></div>

              <img
                src={Right}
                alt="Team working together"
                className="object-cover"
              />
            </div>

            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                Industries We Serve
              </h2>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                At TechProjects, we understand that every industry has its own
                challenges. That’s why we combine technology expertise, domain
                knowledge, and innovation to deliver solutions that fit your
                business — not the other way around.
              </p>
              <p className="text-lg font-400 text-[#404040] leading-relaxed">
                We work with enterprises across retail, government, healthcare,
                logistics, and financial services, helping them modernize,
                secure, and scale with confidence. Whether it’s AI-powered
                automation, digital transformation, or CyberSecurity, our
                solutions are designed to create measurable impact in every
                sector we serve.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-[#F7F7F7] py-12 px-4 md:px-16 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto gap-12 items-center">
            <h2 className="text-6xl font-extrabold text-[#0F172A] mb-8">
              Our Focus Industries
            </h2>
            <p className="text-[#0F172A] text-lg font-400 mb-10">
              We offer comprehensive technology services—from digital
              transformation and consulting to infrastructure, security, and
              staffing—designed to support and scale your business efficiently.
            </p>
            <div className="flex flex-col md:flex-row gap-8 justify-between mt-8">
              <ul className="flex flex-col gap-4 min-w-[400px]">
                {industries.map((item, idx) => (
                  <li key={item.name}>
                    <button
                      className={`w-full flex items-center px-6 py-3 rounded-md transition ${
                        selected === idx
                          ? "bg-activeColor text-white"
                          : "text-[#434253]"
                      } font-500 text-xl`}
                      onClick={() => setSelected(idx)}
                    >
                      <img
                        className="mr-3 w-[18px] h-[18px]"
                        src={
                          selected === idx
                            ? item?.activeIcon
                            : item?.inActiveIcon
                        }
                      />
                      {item.name}
                      {selected === idx && (
                        <i className="fa fa-arrow-right text-xs ml-auto"></i>
                      )}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="bg-white rounded-[30px] shadow p-10 flex flex-col items-center md:w-[580px]">
                <img
                  src={industries[selected].image}
                  alt={industries[selected].name}
                  className="w-[378px] h-[258px] object-cover rounded-3xl mb-6"
                />
                <p className="text-[#212532] text-center mb-8">
                  {industries[selected].description}
                </p>
                <a
                  onClick={() => navTo(industries[selected].cta)}
                  className="text-[#FA3746] font-semibold flex items-center w-full justify-end gap-2 cursor-pointer"
                >
                  Explore {industries[selected].cta} Solutions
                  <i className="fa fa-arrow-right text-xs"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-14 px-4 md:px-20 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <div className="flex items-center mb-3">
                <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
              </div>
              <h2 className="text-7xl font-extrabold text-[#434253] mb-3">
                Why TechProjects for Industries?
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image24}
                  alt="Industries illustration"
                  className="max-w-md w-full object-contain"
                />
              </div>

              <div className="flex-1 w-full space-y-16">
                <ul className="space-y-7 text-xl">
                  <li className="flex flex-col items-start">
                    <div className="flex items-center mb-1">
                      <i
                        className="fa fa-check text-[#F42F39] mr-3"
                        aria-hidden="true"
                      ></i>
                      <span className="font-semibold text-[#0F172A] text-xl">
                        Deep domain expertise in multiple sectors
                      </span>
                    </div>
                  </li>
                  <li className="flex flex-col items-start">
                    <div className="flex items-center mb-1">
                      <i
                        className="fa fa-check text-[#F42F39] mr-3"
                        aria-hidden="true"
                      ></i>
                      <span className="font-semibold text-[#0F172A] text-xl">
                        Proven success with Fortune 500 clients and public
                        agencies
                      </span>
                    </div>
                  </li>
                  <li className="flex flex-col items-start">
                    <div className="flex items-center mb-1">
                      <i
                        className="fa fa-check text-[#F42F39] mr-3"
                        aria-hidden="true"
                      ></i>
                      <span className="font-semibold text-[#0F172A] text-xl">
                        Hybrid U.S.–India model for round-the-clock delivery
                      </span>
                    </div>
                  </li>
                  <li className="flex flex-col items-start">
                    <div className="flex items-center mb-1">
                      <i
                        className="fa fa-check text-[#F42F39] mr-3"
                        aria-hidden="true"
                      ></i>
                      <span className="font-semibold text-[#0F172A] text-xl">
                        Certified partner (MWBE, ISO, Microsoft Gold)
                      </span>
                    </div>
                  </li>
                </ul>

                <a
                  onClick={() => navigate("/CaseStudies")}
                  className="text-[#FA3746] text-xl font-bold flex items-center w-full justify-end gap-2"
                >
                  View Case Studies{" "}
                  <i className="fa fa-arrow-right text-xs mt-1"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Industries;
